module.exports = __webpack_public_path__ + "img/logo.a050b9c3.svg";